import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectRetainerRefinementTable(state),
        type: 'retainer-refinement',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryRetainerRefinement,
    changeFilter: action.changeFilterRetainerRefinement,
    toggleSort: action.toggleSortRetainerRefinement,
    toggleMultiSort: action.toggleMultiSortRetainerRefinement,
    gotoPage: action.gotoPageRetainerRefinement,
    initialColumnsVisibility: action.initialTableSettingsRetainerRefinement,
    toggleColumnVisibility: action.toggleColumnVisibilityRetainerRefinement,
    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/RetainerRefinementSalesOrderSearchContainer.js